<template>
  <div class="flex items-center justify-center min-h-screen bg-slate-100 text-gray-800">
    <div class="text-center">
      <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-sky-600 mx-auto mb-4"></div>
      <p class="text-slate-600 font-semibold">Memproses login SSO...</p>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';

export default {
  name: 'SsoCallbackPage',
  async mounted() {
    const ticket = this.$route.query.ticket;
    if (!ticket) {
      this.failLogin('Ticket SSO tidak ditemukan.');
      return;
    }

    try {
      // Tukar ticket sekali pakai dengan JWT lokal (paritas dengan /login manual)
      const response = await axios.get(`${window.location.origin}/auth/sso/exchange`, {
        params: { ticket },
      });

      localStorage.setItem('token', response.data);
      this.$router.push('/dashboard');
    } catch (err) {
      this.failLogin('Ticket SSO tidak valid atau kadaluarsa. Silakan coba lagi.');
    }
  },
  methods: {
    failLogin(message) {
      Swal.fire({
        icon: 'error',
        title: 'Login SSO Gagal',
        text: message,
        confirmButtonColor: '#0284c7',
      });
      this.$router.push('/login');
    },
  },
};
</script>
